import { jsx } from "react/jsx-runtime";
import { alpha, ButtonBase, styled, svgIconClasses } from "@mui/material";
import { forwardRef } from "react";
import { colorPickerName } from "../../../classes.js";
const doNotForward = /* @__PURE__ */ new Set(["bgcolor", "selected", "ownerState", "contrastColor", "size"]);
const borderWidth = 2;
const outlineWidth = borderWidth;
const borderRadius = 4;
const ChipBase = forwardRef((props, ref) => /* @__PURE__ */ jsx(ButtonBase, { disableRipple: true, ref, ...props }));
const Chip = styled(ChipBase, {
  name: colorPickerName,
  overridesResolver: (_props, styles) => [styles.swatch],
  shouldForwardProp: (prop) => !doNotForward.has(prop),
  slot: "Swatch"
})(({ theme, contrastColor = "#fff", selected = false, bgcolor = "#000", size }) => {
  const darkColor = theme.palette.tidalColors.slateBlueGray.A700;
  const mainColor = theme.palette.primary.main;
  return {
    "&:focus-visible": {
      // figma is 0.12
      outlineColor: selected ? mainColor : `${alpha(darkColor, 0.28)}`
    },
    "&:hover": {
      // figma is 0.04
      outlineColor: selected ? mainColor : `${alpha(darkColor, 0.14)}`
    },
    alignItems: "center",
    backgroundColor: bgcolor,
    borderColor: theme.vars.palette.background.paper,
    borderRadius,
    borderStyle: "solid",
    borderWidth,
    boxShadow: `0px 0px 3px 0px ${alpha(darkColor, 0.56)} inset`,
    color: contrastColor,
    display: "flex",
    flexShrink: 0,
    height: size,
    justifyContent: "center",
    outlineColor: `${alpha(mainColor, selected ? 1 : 0)}`,
    outlineStyle: "solid",
    outlineWidth,
    position: "relative",
    transition: "outline 0.3s ease",
    width: size,
    [`& .${svgIconClasses.root}`]: {
      fontSize: Math.ceil(size * 0.6),
      opacity: selected ? 1 : 0,
      scale: selected ? 1 : 0,
      transition: "opacity 0.18s ease, scale 0.25s ease"
    }
  };
});
export {
  Chip,
  borderWidth,
  outlineWidth
};
//# sourceMappingURL=Chip.js.map
